export default {
  mobile: 480,
  tablet: 950,
  laptop: 1100,
  desktop: Infinity,
}
